module.exports = "<div class=\"kng-icon-button\" [ngClass]=\"{'kng-icon-button-horizontal': type === 'horizontal', 'kng-icon-button-disabled': disabled === true, 'kng-icon-button-message': message === true}\">\r\n  <div class=\"kng-icon-button-container\">\r\n    <i [ngClass]=\"{'kng-icon-rotate': rotate === true}\" class=\"kng-icon {{icon}}\"></i>\r\n    <label><ng-content></ng-content></label>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/kng-icon-button/kng-icon-button.component.html
// module id = ../../../../../src/app/layout/kingswell/kng-icon-button/kng-icon-button.component.html
// module chunks = main